/** Guest journey → Waiver texts: the tour's `waiver_required`, `waiver` and `waiver_link`
 *  context keys, which notifications read (`tour.waiver…`) — not the waivers guests sign
 *  in pre-check-in (above). A falsy context value deletes its key, so "Waiver required" is
 *  on or absent: switching it off removes the key, and the operator's notifications
 *  context (if it sets one) answers again. */
import { Box, Typography } from '@mui/material';

import { contextPath, WAIVER_CONTEXT_KEYS } from '../catalog';

import { TourFieldGrid } from './TourSectionPanel';

export function WaiverTextsBlock() {
  return (
    <Box sx={{ display: 'grid', gap: 0.5 }} data-field-group="waiver">
      <Typography variant="caption" component="h3" color="text.secondary" sx={{ m: 0, fontWeight: 600 }}>
        Waiver texts (notifications)
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Read by notifications, not signed by guests (that is the pre-check-in waivers). Off removes “Waiver required” —
        there is no stored “no”, so the operator’s notification defaults answer again.
      </Typography>
      <TourFieldGrid keys={WAIVER_CONTEXT_KEYS.map(contextPath)} />
    </Box>
  );
}
